import { UnassignTripsFromTripGroupingInput } from '../../lib/types/models/trip-grouping/trip-grouping-input'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function unassignTripsFromTripGrouping(
  input: UnassignTripsFromTripGroupingInput & { tripGroupingId: number }
) {
  const { tripGroupingId, ...rest } = input
  return restApiClient
    .url(
      encodeNestedObject(
        constructApiUrl(API.tripGroupings.unassignTrips.url, { id: tripGroupingId }),
        { ids: rest.tripIds }
      )
    )
    .delete()
}
